import {gettext, interpolate} from 'topmeteo/utils/i18n';

const Message = gettext('The product %(title)s is not available for the selected date.');

const Unavailable = props => (
    <p className="unavailable">
        {interpolate(Message, props)}
    </p>
);

export default Unavailable;
